import styled from "styled-components"

export const BackImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`
